import requests from "./httpService";

const VendorWithdrawServices = {

    getAllWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/vendor/withdraw/all?page=${page}&limit=${limit}`);
    },
    
    getPendingWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/vendor/withdraw/pending?page=${page}&limit=${limit}`);
    },
    
    getApproveWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/vendor/withdraw/success?page=${page}&limit=${limit}`);
    },

    getRejectedWithdrawList: async (page = 1, limit = 20) => {
        return requests.get(`/vendor/withdraw/reject?page=${page}&limit=${limit}`);
    },
    
    getWithdrawDetails: async (id) => {
        const res= requests.get(`/vendor/withdraw/${id}`);
        return res
    },
    approveWithdraw: async (id, body) => {   
        return requests.put(`/vendor/withdraw/${id}/approve`, body);
    },
    
    rejectWithdraw: async (id,body) => {
        return requests.put(`/vendor/withdraw/${id}/reject`, body);
    },
    
  updateWithdrawStatus: async (id, body) => {
        return requests.put(`/vendor/withdraw/${id}`, body);
    },
    deleteWithdraw: async (id) => {
        return requests.delete(`/vendor/withdraw/${id}`);
    }
};

export default VendorWithdrawServices;